<template>
  <div class="document-container">
    <div class="doc-name">
      <p class="name">开发注意事项</p>
      <p class="update-time">{{currentParams.updateTime}}</p>
    </div>
    <div class="request-module-box">
      <div class="module-name">
        <span>注意事项</span>
      </div>
      <div class="module-text">
        <span>1、所有请求都使用POST方式与油柑网API服务通进行通信,请求参数统一使用UTF-8编码。</span>
      </div>
      <div class="module-text">
        <span>2、开发注意(sign签名,appId,params为请求必传参数)。</span>
        <p>* sign签名 为加密参数。</p>
        <p>* appId 用户应用程序id。</p>
        <p>* params 为接口业务参数。</p>
      </div>
      <div class="module-text">
        <span>3、appId:</span>
        <p>* appId为通过对接申请后由油柑网平台发放。</p>
      </div>
      <div class="module-text">
        <span>4、sign签名规则:</span>
        <p>* 参数名 ASCII 码从小到大排序(字典序)。</p>
        <p>* 如果参数的值为空不参与签名。</p>
        <p>* 参数名区分大小写。</p>
        <p>
          * 签名生成请用md5加密方法 举例md5(appKey + params)
          <em class="color-red">注 params 为当前业务接口字符串JSON对象</em>
          。
        </p>
      </div>
      <div class="module-text">
        <span>5、params接口业务参数:</span>
        <p>* 根据不同的接口名称附带相对应的业务参数。</p>
      </div>
      <div class="module-text">
        <span>6、请注意，当您填写联系人手机号码时，请不要填写已经注册了油柑网的手机号码，因为这个手机号码在开通对外接口后会被禁止登陆油柑网。</span>
      </div>
      <div class="module-text">
        <span>7、您完整填写表单并提交后，我们会在10个工作日内联系您，并与您讨论具体的接入方式。</span>
      </div>
      <div class="request-module-box">
        <div class="module-name">
          <span>请求示例</span>
        </div>
        <div class="code-example">
          <json-viewer :value="code" :expand-depth="5" boxed copyable></json-viewer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tables from "@/components/Tables";
import publicData from "@/api/public/index";
import { createOrderApi } from "@/api/order/index";
export default {
  components: {
    Tables
  },
  data() {
    return {
      publicParams: publicData,
      currentParams: createOrderApi,
      code: {
        sign: "ec40c739613802655e3720aaf8406531",
        appId: "9527",
        method: "ygw.api.order.price",
        params: {
          distributionType: 0,
          express: "JD",
          recipient: {
            provinceCode: 440000
          },
          goodsList: [
            {
              goodsCode: "04SUP000001",
              quantity: 10000
            }
          ]
        }
      }
    };
  }
};
</script>
<style lang="less" scoped>
.document-container {
  padding: 0 40px;
  text-align: left;
  .color-red {
    color: red;
  }
  .doc-name {
    border-bottom: 1px solid #dedede;
    > .name {
      font-size: 24px;
      text-align: left;
      color: #333;
    }
    > .update-time {
      margin-top: 10px;
      margin-bottom: 30px;
      font-size: 12px;
      color: #666666;
    }
  }
  .request-module-box {
    .module-name {
      height: 60px;
      font-size: 16px;
      line-height: 60px;
      color: #333;
    }
    .table-box {
    }
    .module-text {
      font-size: 14px;
      line-height: 40px;
      text-align: justify;
      a {
        color: #4fbfff;
        text-decoration: underline;
      }
    }
    .module-img {
      margin-top: 10px;
      img {
        width: 100%;
        display: block;
      }
    }
    .code-example {
      background-color: #e8e8e8;
    }
  }
}
</style>